import { useParams } from 'next/navigation'
import { useLocale, useTranslations } from 'next-intl'
import { useEffect } from 'react'

import { useTossPaymentWidgetInfo } from '../../api/get-toss-payment-widget-info'
import {
  AGREEMENT_SELECTOR,
  PAYMENT_SELECTOR,
  useTossWidget,
} from '../../lib/toss-widget'

type Params = {
  contractId: string
}

export const PaymentMethod = () => {
  const locale = useLocale()
  const t = useTranslations('card_payment')

  const params = useParams<Params>()
  const contractId = params?.contractId

  const { fetchPaymentWidgets, renderPaymentWidgets } = useTossWidget()

  const { widgetInfo } = useTossPaymentWidgetInfo(Number(contractId))

  const isEnglish = locale === 'en'

  useEffect(() => {
    if (widgetInfo) {
      void fetchPaymentWidgets(widgetInfo)
    }
  }, [fetchPaymentWidgets, widgetInfo])

  useEffect(() => {
    void renderPaymentWidgets()
  }, [renderPaymentWidgets])

  return (
    <div>
      <h3 className="typo-body1 mb-3 p-6 pb-0 text-start font-semibold text-black">
        {t('payment_method.title')}
      </h3>
      {isEnglish && (
        <div className="mb-3 space-y-3 px-6 text-start">
          <p className="typo-label1 font-normal text-gray-900">
            Please select a payment method below.
          </p>
          <div className="bg-gray-0 typo-label1-reading space-y-1 rounded-sm p-4">
            <p className="font-medium text-black">
              International cards accpeted
            </p>
            <p className="font-semibold text-purple-500">
              VISA, MasterCard, JCB, UnionPay, AMEX.
            </p>
          </div>
        </div>
      )}
      <div id={PAYMENT_SELECTOR} />
      <div id={AGREEMENT_SELECTOR} />
    </div>
  )
}

export const PaymentMethodFallback = () => {
  const t = useTranslations('card_payment')

  return (
    <div>
      <h3 className="typo-body1 p-6 pb-3 text-start font-semibold text-black">
        {t('payment_method.title')}
      </h3>
      <div className="typo-label1 bg-gray-0 m-6 mt-0 flex h-[200px] items-center justify-center rounded-md whitespace-break-spaces text-gray-900">
        {t('payment_method.error.invalid_payment')}
      </div>
    </div>
  )
}
